import PropTypes from "prop-types";
import { classNames } from "@gonoodle/gn-universe-ui";

export default function ChampPointsStamp({ className, points, size = "sm" }) {
  return (
    <span
      className={classNames("relative", size === "sm" && "text-xs", className)}
    >
      <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-bold text-white">
        {points}
      </span>

      <svg
        className={classNames(
          size === "sm" && "w-6 h-6",
          size === "lg" && "w-12 h-12",
        )}
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <path
          d="M14.5 0L17.0082 2.69963L20.3977 1.25359L21.591 4.74002L25.2756 4.79761L24.9477 8.468L28.2903 10.0193L26.4979 13.239L28.9206 16.0157L25.9735 18.228L27.0574 21.75L23.4653 22.5724L23.0229 26.2307L19.4069 25.521L17.5147 28.6831L14.5 26.564L11.4853 28.6831L9.59313 25.521L5.97711 26.2307L5.5347 22.5724L1.94263 21.75L3.02645 18.228L0.0794325 16.0157L2.50209 13.239L0.709681 10.0193L4.05227 8.468L3.7244 4.79761L7.40896 4.74002L8.60232 1.25359L11.9918 2.69963L14.5 0Z"
          fill="#5D15E3"
        />
      </svg>
    </span>
  );
}

ChampPointsStamp.propTypes = {
  className: PropTypes.string,
  points: PropTypes.number.isRequired,
  size: PropTypes.oneOf(["sm", "lg"]),
};

ChampPointsStamp.defaultProps = {
  className: undefined,
  size: "sm",
};
